import React, { useCallback } from 'react';
import { Modal, FormField, Message, Input, Button, Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import styles from './PromotionModal.module.scss';
import { useForm } from '../../hooks';
import api from '../../api';

const promotionMapMessage = new Map([
  ['email', '邮箱格式错误'],
  ['Email already in use', '邮箱已被使用'],
  ['promotion code already in use', '推广码已被使用'],
  ['phone', '手机号码格式错误'],
  ['promotion code', '推广码格式不正确，只能包含数字和字母'],
]);
const promotionMapColor = new Map([
  ['email', 'red'],
  ['phone', 'red'],
  ['Email already in use', 'red'],
  ['promotion code already in use', 'red'],
  ['promotion code', 'red'],
]);
function PromotionModal({ onClose, edit, onInfo }) {
  const isEdit = React.useMemo(() => Object.keys(edit).length > 0, [edit]);
  const [message, setMessage] = React.useState(null);
  const [data, handleFieldChange] = useForm(
    isEdit
      ? edit
      : {
          name: '',
          phone: '',
          email: '',
          promotionCommission: '',
          promotionCode: '',
        },
  );

  const handleSubmit = useCallback(() => {
    if (Object.values(data).every((value) => !value)) {
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      setMessage('email');
      return;
    }
    if (!/^1[3456789]\d{9}$/.test(data.phone)) {
      setMessage('phone');
      return;
    }
    if (!/^[A-Za-z0-9]+$/.test(data.promotionCode)) {
      setMessage('promotion code');
      return;
    }
    if (!isEdit) {
      api
        .createPromotion({ ...data })
        .then(() => {
          onInfo();
          onClose();
        })
        .catch((err) => {
          setMessage(err.message);
        });
    } else {
      api
        .updatePromotion({ ...data })
        .then(() => {
          onInfo();
          onClose();
        })
        .catch((err) => {
          setMessage(err.message);
        });
    }
  }, [data, isEdit, onClose, onInfo]);

  const handleDelete = useCallback(() => {
    if (!isEdit || !data.id) {
      return;
    }
    api
      .deletePromotion(data.id)
      .then(() => {
        onInfo();
        onClose();
      })
      .catch((err) => {
        setMessage(err.message);
      });
  }, [data.id, isEdit, onClose, onInfo]);

  const onMessageDismiss = () => {
    setMessage(null);
  };

  return (
    <Modal open closeIcon size="small" centered={false} onClose={onClose}>
      <Modal.Header>{isEdit ? '修改推广人' : '新增推广人'}</Modal.Header>
      <Modal.Content scrolling>
        {message && (
          <Message color={promotionMapColor.get(message)} visible onDismiss={onMessageDismiss}>
            {promotionMapMessage.get(message)}
          </Message>
        )}

        <Form className={styles.form}>
          <FormField className={styles.field}>
            <p>
              姓名
              <span>*</span>
            </p>
            <Input
              name="name"
              type="text"
              placeholder="请输入姓名"
              value={data.name}
              onChange={handleFieldChange}
            />
          </FormField>
          <FormField className={styles.field}>
            <p>
              手机
              <span>*</span>
            </p>
            <Input
              name="phone"
              type="number"
              placeholder="请输入手机号码"
              value={data.phone}
              onChange={handleFieldChange}
            />
          </FormField>
          <FormField className={styles.field}>
            <p>
              邮箱
              <span>*</span>
            </p>
            <Input
              name="email"
              type="text"
              placeholder="请输入电子邮箱"
              value={data.email}
              onChange={handleFieldChange}
            />
          </FormField>
          <FormField className={styles.field}>
            <p>
              佣金比例（%）
              <span>*</span>
            </p>
            <Input
              name="promotionCommission"
              type="number"
              placeholder="请输入佣金比例"
              value={data.promotionCommission}
              onChange={handleFieldChange}
            />
          </FormField>
          <FormField className={styles.field}>
            <p>推广码</p>
            <Input
              name="promotionCode"
              type="text"
              placeholder="请输入推广码"
              value={data.promotionCode}
              onChange={handleFieldChange}
            />
          </FormField>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        {isEdit && (
          <Button negative floated="left" onClick={handleDelete}>
            删除
          </Button>
        )}
        <Button primary onClick={handleSubmit}>
          {isEdit ? '修改' : '新增'}
        </Button>
        <Button onClick={onClose}>取消</Button>
      </Modal.Actions>
    </Modal>
  );
}
PromotionModal.propTypes = {
  edit: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onInfo: PropTypes.func.isRequired,
};
PromotionModal.defaultProps = {
  edit: {},
};
export default PromotionModal;
